import { render, staticRenderFns } from "./modalConfiguracionMedico.vue?vue&type=template&id=4184a93c&scoped=true&"
import script from "./modalConfiguracionMedico.vue?vue&type=script&lang=js&"
export * from "./modalConfiguracionMedico.vue?vue&type=script&lang=js&"
import style0 from "./modalConfiguracionMedico.vue?vue&type=style&index=0&id=4184a93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184a93c",
  null
  
)

export default component.exports